import AdjustWeb from '@adjustcom/adjust-web-sdk'

import {
  ADJUST_WEB_TOKEN,
  IS_PRERENDERING,
  IS_PRODUCTION,
} from '@/init/settings'
import { platform } from '@/services/platform'

/**
 * Initialize the Adjust Web SDK.
 *
 * Prerender runs this in JSDOM and copies every console call into the build
 * log. initSdk always prints "Log level set to …", including log level "none".
 * There is no browser session to attribute, so skip startup.
 */
export async function initAdjustWeb(): Promise<void> {
  if (IS_PRERENDERING) {
    return
  }

  const info = await platform.deviceInfo()
  if (info.platform !== 'web') {
    return
  }

  const environment = IS_PRODUCTION ? 'production' : 'sandbox'
  const config: AdjustWeb.InitOptions = {
    appToken: ADJUST_WEB_TOKEN,
    environment: environment,
  }
  if (!IS_PRODUCTION) {
    config.logLevel = 'verbose'
  }
  AdjustWeb.initSdk(config)
}
